export var actualMap = false;

// Declaration
export class treeclimateMap {
  constructor(map, view) {
    this.globalMap = map;
    this.globalView = view;
  }

  static getActualMapFromClass() {
    return actualMap?.globalMap ?? null;
  }

  static getActualViewFromClass() {
    return actualMap?.globalView ?? null;
  }
}

export function setActualMap(treeclimateClass) {
  actualMap = treeclimateClass;
}

export function getActualMap() {
  return actualMap;
}

export function getGlobalMap() {
  return actualMap?.globalMap ?? null;
}
